/// useTranslation not needed
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { skipToken } from '@reduxjs/toolkit/query/react'
import posthog from '../../api/posthog'
import Layout from '../Layout'
import Loading from '../Loading'
import EditRequestForm from './EditRequestForm'
import FourOhFour from '../FourOhFour'
import { useGetCollectionRequestQuery } from '../../store/apiSlice'

const EditRequest: React.FC = () => {

  const params = useParams()

  const {
    data: request,
    isFetching: isFetchingRequest,
    isError,
  } = useGetCollectionRequestQuery(params.id ?? skipToken)

  useEffect(() => {
    posthog.capture('$pageview')
  }, [])

  return (
    <Layout>
      <>
        {!isFetchingRequest && request && (
          <EditRequestForm request={request} />
        )}
        {isFetchingRequest && <Loading />}
        {isError && <FourOhFour />}
      </>
    </Layout>
  )
}

export default EditRequest